import { render } from "./pedido-detalhe.vue?vue&type=template&id=2db8c829"
import script from "./pedido-detalhe.vue?vue&type=script&lang=js"
export * from "./pedido-detalhe.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__